import React, { useEffect } from "react";

export default function Footer() {
  return (
    <footer className="main-footer text-center">
      <p className="m-0">
        ۱۴۰۲ - کلیه حقوق متعلق به شرکت فن آوای هوش مصنوعی است.
      </p>
    </footer>
  );
}
